import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        setUser(data.user);
        // Route by role
        window.history.replaceState(null, "", "/");
        if (data.user.role === "driver") navigate("/driver", { replace: true });
        else if (data.user.role === "store_admin") navigate("/admin", { replace: true });
        else navigate("/", { replace: true });
      } catch (e) {
        console.error("Session exchange failed", e);
        navigate("/", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0B0A] text-[#F3F4F3]">
      <div className="text-center">
        <div className="inline-block w-8 h-8 border-2 border-[#3D5A45] border-t-transparent rounded-full animate-spin mb-4" />
        <p className="text-sm text-[#A1A7A1] tracking-wide">Signing you in…</p>
      </div>
    </div>
  );
}
